export default "__VITE_ASSET__K89WyW1g__"